let checkFileSize, generateErrorMessage;

checkFileSize = function(file, size) {
  return !!file && file.name !== void 0 && ((file.size).toFixed(4)) <= size;
};

window.fileSizeNotInLimit = function(file, event, target_modal_crop_button, limit) {
  if (!checkFileSize(file, limit)) {
    if (!!file)
    {
      alert("Unfortunately your file is too large, please upload a version smaller than " + (limit.toString()/1024/1024) + "MB");
    }
    if (!!target_modal_crop_button) {
      if($(event.target).siblings(target_modal_crop_button).length > 0)
        $(event.target).siblings(target_modal_crop_button).css("display", "none");
      else
        $(target_modal_crop_button).css("display", "none");
    }
    return true;
  } else {
    return false;
  }
};
